import download from 'downloadjs';
import moment from 'moment';
import { useMutation } from 'react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';
import { useToast } from '@frontend/components';

import type {
  DownloadOrderListCsvQueryVars,
  DownloadOrderListCsvQueryParams,
  DownloadOrderListCsvQueryData,
} from './types';

export const useDownloadOrderListCsv: MutationFunction<
  DownloadOrderListCsvQueryData,
  DownloadOrderListCsvQueryVars,
  [DownloadOrderListCsvQueryParams]
> = (params, { requestOptions, queryOptions = {} } = {}) => {
  const { groupId } = params;
  const urlPath = `/orders/groups/${groupId}/export`;
  const request = useRequest(requestOptions);
  const { onSuccess: onSuccessProp, ...restQueryOptions } = queryOptions;
  const onSuccess = (
    ...args: Parameters<NonNullable<typeof onSuccessProp>>
  ) => {
    const [data] = args;
    const blob = new Blob([data]);
    download(blob, `orders_${moment().format('YYYYMMDD')}.csv`);
    if (onSuccessProp) {
      onSuccessProp(...args);
    }
  };
  const toast = useToast();
  return useMutation({
    ...restQueryOptions,
    mutationKey: ['orders', 'downloadOrderListCsv'],
    mutationFn: (requestData) => {
      return request(urlPath, {
        init: {
          method: 'GET',
        },
        query: requestData,
      });
    },
    onSuccess,
    onError: (error) => {
      let description;
      if (error instanceof Error) {
        description = error.message;
      }
      toast({
        status: 'error',
        title: "Couldn't export orders",
        description,
      });
    },
  });
};
